var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.optionModel.showHeader
    ? _c(
        "el-form-item",
        { attrs: { label: "可刷新" } },
        [
          _c("el-switch", {
            model: {
              value: _vm.optionModel.showRefresh,
              callback: function ($$v) {
                _vm.$set(_vm.optionModel, "showRefresh", $$v)
              },
              expression: "optionModel.showRefresh",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }